<template>
  <div class="quantity-toggle checkout-ticket-card__quantity">
    <button type="button" :disabled="disabled || quantity <= minQuantity" :aria-label="`Restar ${name}`" @click="$emit('decrement')">&minus;</button>
    <input type="text" :value="quantity" :aria-label="`Cantidad de ${name}`" readonly>
    <button type="button" :disabled="disabled || !available || quantity >= maxQuantity" :aria-label="`Sumar ${name}`" @click="$emit('increment')">&plus;</button>
  </div>
</template>
<script>
export default {
  name: 'CheckoutQuantityControl',
  props: {
    name: { type: String, required: true }, quantity: { type: Number, default: 0 },
    maxQuantity: { type: Number, default: Infinity }, available: { type: Boolean, default: true },
    minQuantity: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  emits: ['increment', 'decrement'],
}
</script>
<style scoped>
.checkout-ticket-card__quantity input { font-family: var(--fomo-font-body) !important; font-size: 1rem; }
.checkout-ticket-card__quantity button:active:not(:disabled) { transform: scale(0.9); }
.checkout-ticket-card__quantity button:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
